import { render, staticRenderFns } from "./PortalPopups.vue?vue&type=template&id=274b28c9&"
import script from "./PortalPopups.vue?vue&type=script&lang=js&"
export * from "./PortalPopups.vue?vue&type=script&lang=js&"
import style0 from "./PortalPopups.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports